import { T_Activity } from "@repo-sapiens/data-access-models";
import axios from "axios";

export const recordActivity = async (apiUrl: string, data: {
  data: Omit<T_Activity, 'date' | 'user'> & { user: string };
  ipAddress?: string;
}) => {
  try {
    const response = await axios.post(
      `${apiUrl}/api/record-activity`,
      data,
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};